/**
 * Invalidates TanStack Query caches when navigating to specific routes.
 * Kept minimal to avoid 429 rate limits - mutations already invalidate on success.
 */

import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function RouteInvalidationHandler() {
	const queryClient = useQueryClient();
	const location = useLocation();
	const prevPathRef = useRef(location.pathname);

	useEffect(() => {
		const path = location.pathname;
		const prevPath = prevPathRef.current;
		prevPathRef.current = path;

		if (path === prevPath) return;

		// Only invalidate when returning to list pages (not on every navigation)
		// Mutations (save, create, delete) already invalidate - this catches
		// external updates. Reduced scope to avoid 429.
		if (path === "/kyc" && !prevPath.startsWith("/kyc/")) {
			queryClient.invalidateQueries({ queryKey: ["kyb"] });
		} else if (path === "/" && !prevPath.startsWith("/wallet/")) {
			queryClient.invalidateQueries({ queryKey: ["wallets"] });
		} else if (path === "/settings") {
			queryClient.invalidateQueries({ queryKey: ["documentTemplates"] });
		}
	}, [location.pathname, queryClient]);

	return null;
}
